import type { ComboboxProps } from '../Combobox';

export function assertMultiSelect<
  TValue extends string,
  TMultiselect extends boolean,
>({
  multiselect,
  value,
  maxSelectedOptions,
}: Pick<
  ComboboxProps<TValue, TMultiselect>,
  'multiselect' | 'value' | 'maxSelectedOptions'
>): void {
  if (!multiselect) {
    return;
  }

  if (!!value && !Array.isArray(value)) {
    throw new Error('value must be an array for multiselect combobox');
  }

  if (maxSelectedOptions && maxSelectedOptions < 1) {
    throw new Error('maxSelectedOptions must be greater than 0');
  }
}
